/*local*/
// export const APIHOST = "http://localhost:53025";
//
//  export const APIHOST = "https://gmtest.post.uz";
export const APIHOST = "";
// export const APIHOST = "http://84.54.74.198:3391";
export const LimitPerPrintPackage = 10;
export const LimitPerPrintByClient = 100;
export const LimitPerPrintPackageEhm = 30;
export const DateLimitForFilters = 30;
